
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    FSDRIVER_ACTION,
    ALL_FSDRIVER,
    ADD_FSDRIVER,
    FETCH_FSDRIVER,
    EDIT_FSDRIVER,
    DELETE_FSDRIVER
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * FS DRIVER Actions
 */

    export const allFSDriver = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: FSDRIVER_ACTION });
            return axios.get(AppConfig.apiurl+'/api/gettqfsdriver', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_FSDRIVER, payload: alldata });
            });
        }        
    
    }

    export const addFSDriver = (data, cntclub, cntball, cntrate, cntsmash, cntcry, cntaoa, cntpath, cnthsp, cntftp, cntftt) =>{
    
        var payload={
            "totval":1,
            "student_1":data.target.student.value,
            "sgdate":data.target.seldate.value,            
            "inference_1":data.target.inference_1.value,
            "notes_1":data.target.notes_1.value,
            
        }

        var clubarr=[];
        for(let i = 0; i<cntclub; i++) {  
            var sepday='clubspeed_'+i;            
            var sedyval=data.target[sepday].value;
            clubarr.push(sedyval);
        }

        var ballarr=[];
        for(let i = 0; i<cntball; i++) {  
            var sepday='ball_'+i;            
            var sedyval=data.target[sepday].value;
            ballarr.push(sedyval);
        }

        var ratearr=[];
        for(let i = 0; i<cntrate; i++) {  
            var sepday='rate_'+i;            
            var sedyval=data.target[sepday].value;
            ratearr.push(sedyval);
        }

        var smasharr=[];
        for(let i = 0; i<cntsmash; i++) {  
            var sepday='smash_'+i;            
            var sedyval=data.target[sepday].value;
            smasharr.push(sedyval);
        }

        var cryarr=[];
        for(let i = 0; i<cntcry; i++) {  
            var sepday='carry_'+i;            
            var sedyval=data.target[sepday].value;
            cryarr.push(sedyval);
        }

        var aoaarr=[];
        for(let i = 0; i<cntaoa; i++) {  
            var sepday='aoa_'+i;            
            var sedyval=data.target[sepday].value;
            aoaarr.push(sedyval);
        }

        var patharr=[];
        for(let i = 0; i<cntpath; i++) {  
            var sepday='path_'+i;            
            var sedyval=data.target[sepday].value;
            patharr.push(sedyval);
        }

        var hsparr=[];
        for(let i = 0; i<cnthsp; i++) {  
            var sepday='hsp_'+i;            
            var sedyval=data.target[sepday].value;
            hsparr.push(sedyval);
        }

        var ftparr=[];
        for(let i = 0; i<cntftp; i++) {  
            var sepday='ftp_'+i;            
            var sedyval=data.target[sepday].value;
            ftparr.push(sedyval);
        }

        var fttarr=[];
        for(let i = 0; i<cntftt; i++) {  
            var sepday='ftt_'+i;            
            var sedyval=data.target[sepday].value;
            fttarr.push(sedyval);
        }

        var clbspeed=clubarr.join(",");
        var ball=ballarr.join(",");
        var smash=smasharr.join(",");
        var rate=ratearr.join(",");
        var carry=cryarr.join(",");
        var aoa=aoaarr.join(",");
        var path=patharr.join(",");
        var hsp=hsparr.join(",");
        var ftp=ftparr.join(",");
        var ftt=fttarr.join(",");
        payload["clsp_1"]=clbspeed;   
        payload["basp_1"]=ball;   
        payload["smash_1"]=smash;   
        payload["sprt_1"]=rate;   
        payload["carry_1"]=carry;   
        payload["aoa_1"]=aoa;   
        payload["path_1"]=path;   
        payload["hsp_1"]=hsp;
        payload["ftp_1"]=ftp;
        payload["ftt_1"]=ftt;

        return (dispatch) => { 
            dispatch({ type:FSDRIVER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addtqfsdriver', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allFSDriver()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_FSDRIVER});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchFSDriver = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:FSDRIVER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/fetchtqfsdriver', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_FSDRIVER, payload: resdata.data[0]});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editFSDriver = (data, id, cntclub, cntball, cntrate, cntsmash, cntcry, cntaoa, cntpath, cnthsp, cntftp, cntftt) =>{
    
        var payload={
            "id":id,
            "student":data.target.student.value,
            "sgdate":data.target.seldate.value,            
            "inference":data.target.inference_1.value,
            "notes":data.target.notes_1.value,
        }

        var clubarr=[];
        for(let i = 0; i<cntclub; i++) {  
            var sepday='clubspeed_'+i;            
            var sedyval=data.target[sepday].value;
            clubarr.push(sedyval);
        }

        var ballarr=[];
        for(let i = 0; i<cntball; i++) {  
            var sepday='ball_'+i;            
            var sedyval=data.target[sepday].value;
            ballarr.push(sedyval);
        }

        var ratearr=[];
        for(let i = 0; i<cntrate; i++) {  
            var sepday='rate_'+i;            
            var sedyval=data.target[sepday].value;
            ratearr.push(sedyval);
        }

        var smasharr=[];
        for(let i = 0; i<cntsmash; i++) {  
            var sepday='smash_'+i;            
            var sedyval=data.target[sepday].value;
            smasharr.push(sedyval);
        }

        var cryarr=[];
        for(let i = 0; i<cntcry; i++) {  
            var sepday='carry_'+i;            
            var sedyval=data.target[sepday].value;
            cryarr.push(sedyval);
        }

        var aoaarr=[];
        for(let i = 0; i<cntaoa; i++) {  
            var sepday='aoa_'+i;            
            var sedyval=data.target[sepday].value;
            aoaarr.push(sedyval);
        }

        var patharr=[];
        for(let i = 0; i<cntpath; i++) {  
            var sepday='path_'+i;            
            var sedyval=data.target[sepday].value;
            patharr.push(sedyval);
        }

        var hsparr=[];
        for(let i = 0; i<cnthsp; i++) {  
            var sepday='hsp_'+i;            
            var sedyval=data.target[sepday].value;
            hsparr.push(sedyval);
        }

        var ftparr=[];
        for(let i = 0; i<cntftp; i++) {  
            var sepday='ftp_'+i;            
            var sedyval=data.target[sepday].value;
            ftparr.push(sedyval);
        }

        var fttarr=[];
        for(let i = 0; i<cntftt; i++) {  
            var sepday='ftt_'+i;            
            var sedyval=data.target[sepday].value;
            fttarr.push(sedyval);
        }

        var clbspeed=clubarr.join(",");
        var ball=ballarr.join(",");
        var smash=smasharr.join(",");
        var rate=ratearr.join(",");
        var carry=cryarr.join(",");
        var aoa=aoaarr.join(",");
        var path=patharr.join(",");
        var hsp=hsparr.join(",");
        var ftp=ftparr.join(",");
        var ftt=fttarr.join(",");
        payload["clsp"]=clbspeed;   
        payload["basp"]=ball;   
        payload["smash"]=smash;   
        payload["sprt"]=rate;   
        payload["carry"]=carry;   
        payload["aoa"]=aoa;   
        payload["path"]=path;   
        payload["hsp"]=hsp;
        payload["ftp"]=ftp;
        payload["ftt"]=ftt;
        
        return (dispatch) => { 
            dispatch({ type:FSDRIVER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/edittqfsdriver', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allFSDriver()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_FSDRIVER});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


    export const deleteFSDriver = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:FSDRIVER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deletetqfsdriver', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allFSDriver()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_FSDRIVER});                    
                }                
                
            });
        
        }
    }


   

